import { render, staticRenderFns } from "./GSelectLanguage.vue?vue&type=template&id=790ff8bf&"
import script from "./GSelectLanguage.vue?vue&type=script&lang=js&"
export * from "./GSelectLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790ff8bf')) {
      api.createRecord('790ff8bf', component.options)
    } else {
      api.reload('790ff8bf', component.options)
    }
    module.hot.accept("./GSelectLanguage.vue?vue&type=template&id=790ff8bf&", function () {
      api.rerender('790ff8bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/GSelectLanguage.vue"
export default component.exports